import ReactDOM from 'react-dom/client'
// import { i18nReady } from '@/lang'
import App from './App.tsx'
import '@/assets/style/global.scss'
import '@/assets/style/rtl.scss'

// 考虑到会延长首页的加载时间，这里不做 i18nReady 的等待，改成直接渲染 App，并补充i18nReady Updated页面的机制
// i18nReady.then(() => {
//   ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
// })
ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
